import { render, staticRenderFns } from "./NewOTPSummary.vue?vue&type=template&id=31a3ed4e&scoped=true"
import script from "./NewOTPSummary.vue?vue&type=script&lang=js"
export * from "./NewOTPSummary.vue?vue&type=script&lang=js"
import style0 from "./NewOTPSummary.vue?vue&type=style&index=0&id=31a3ed4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a3ed4e",
  null
  
)

export default component.exports